import { Avatar, AvatarProps, ImageSize } from './avatar.component';

import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import defaultClinicSvg from '@/assets/avatars/default-clinic.svg?url';
import defaultBranchAvatarSvg from '@/assets/avatars/default-branch-avatar.svg?url';
import defaultProfessionalSvg from '@/assets/avatars/default-professional.svg?url';
import defaultLaboratorySvg from '@/assets/avatars/default-laboratory.svg?url';

export interface EntityAvatarProps extends Omit<AvatarProps, 'src'> {
  src?: string | null;
  size?: ImageSize;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  type: EntityTypeEnum;
  shouldAddLightbox?: boolean;
}

function getDefaultSrc(type: EntityTypeEnum): string {
  switch (type) {
    case EntityTypeEnum.CLINIC:
      return defaultClinicSvg;
    case EntityTypeEnum.BRANCH:
      return defaultBranchAvatarSvg;
    case EntityTypeEnum.PROFESSIONAL:
      return defaultProfessionalSvg;
    case EntityTypeEnum.LABORATORY_COLLECT_POINT:
      return defaultLaboratorySvg;
    default:
      throw new Error('Invalid type provided to PartnerAvatar component');
  }
}

export function EntityAvatar(props: EntityAvatarProps) {
  const { src, type, shouldAddLightbox = false, size = 'xl', ...restProps } = props;

  return (
    <Avatar
      size={size}
      src={src || getDefaultSrc(type)}
      shouldAddLightbox={!!src && shouldAddLightbox}
      {...restProps}
    />
  );
}
